import { cmhc_rate as cmhcRate } from '@ratehub/mortgage-calculations';


export default function calculateCMHCInsurance(propertyValue, downPayment, termInMonths = 300) {
    const principal = Math.max(propertyValue - downPayment, 0);
    const loanToValue = propertyValue ? (principal / propertyValue) : 0;
    const rate = Math.max(cmhcRate(loanToValue, termInMonths / 12), 0);

    return Math.round(principal * rate);
}